// Products with this tag (e.g. rental batteries) can only be rented as extras of a drone rental
export const RENTAL_EXTRA_ONLY_TAG = 'rental-extra-only'

export const isRentalExtraOnly = (tags) =>
  tags?.some((tag) => tag?.toLowerCase() === RENTAL_EXTRA_ONLY_TAG) || false

const getAttributeValue = (item, key) => item?.attributes?.find((attr) => attr?.key === key)?.value

// Extra-only cart items whose parent rental is not in the cart
export const getOrphanRentalExtras = (cartItems = []) => {
  const parentIds = cartItems.map((item) => getAttributeValue(item, '_id')).filter(Boolean)

  return cartItems.filter((item) => {
    if (!isRentalExtraOnly(item?.product?.tags)) return false

    const parentId = getAttributeValue(item, '_parent_id')

    return !parentId || !parentIds.includes(parentId)
  })
}
